export default __webpack_public_path__ + "static/media/BuddyLoopsWeb.8bb482b6.jpg";